import React from "react";
import BasicCustomField from "../BasicCustomField";
import { Calculation } from "../../../../../../src/application/Contracts";
import MatchingUnitModel = Calculation.MatchingUnitModel;
import { round, upperFirst } from "lodash";
import OperatingMode = Calculation.OperatingMode;
import formModelStore from "../../../../../store/FormModelStore";
import getOperatingModeName = Calculation.getOperatingModeName;

export default class TwsMatchingUnit extends BasicCustomField {

    onChangeInput = (matchingUnitModel: MatchingUnitModel) => {
        this.onChange(matchingUnitModel);
    }

    getKeyForRow = (matchingUnitModel: MatchingUnitModel): string => {
        return `${matchingUnitModel.storage}_${matchingUnitModel.p}`;
    }
    renderRow = (matchingUnitModel: MatchingUnitModel) => {
        return <tr key={this.getKeyForRow(matchingUnitModel)}
            className={this.props.readonly && this.checkedRow(this.getKeyForRow(matchingUnitModel)) ? `selected` : ''}>
            {!this.props.readonly && <td className={`input-cell`}>
                <div className={`table-radio-button`}>
                    <input id={`matching-unit-model-${this.getKeyForRow(matchingUnitModel)}`} type={"radio"}
                        checked={this.checkedRow(this.getKeyForRow(matchingUnitModel))}
                        name={`matching-unit-model`}
                        onChange={() => this.onChangeInput(matchingUnitModel)} />
                    <label htmlFor={`matching-unit-model-${this.getKeyForRow(matchingUnitModel)}`}></label>
                </div>
            </td>}
            <td>{round(matchingUnitModel.p ?? 0)}</td>
            <td>{round(matchingUnitModel.storage)}</td>
            <td>{__(getOperatingModeName(matchingUnitModel.operatingMode))}</td>
            <td>{matchingUnitModel.loadTimeWithRecyclingReadable}</td>
        </tr>
    }

    checkedRow = (row: string) => {
        let key = `${formModelStore.formModel?.inputMethod?.installationTypeCalculation?.selectedUnitModel?.value?.storage}_${formModelStore.formModel?.inputMethod?.installationTypeCalculation?.selectedUnitModel?.value?.p}`;
        return key === row;
    }
    renderEmpty = () => {
        return <div className={`empty-expandable-container-results`}>{__('No matching units')}</div>
    }

    render() {
        const matchingUnitModels = this.props.additionalModel as MatchingUnitModel[];
        if (matchingUnitModels === undefined || matchingUnitModels?.length === 0) {
            return this.renderEmpty();
        }

        return <React.Fragment>
            <table className={`step-stripped-table data-only`}>
                <thead>
                    <tr>
                        {!this.props.readonly && <th></th>}
                        <th>{__('P (kW)')}</th>
                        <th>{__('Storage (liters)')}</th>
                        <th>{__('Operating mode')}</th>
                        <th>{__('Load time*')}</th>
                    </tr>
                </thead>
                <tbody>
                    {matchingUnitModels.map(this.renderRow)}
                </tbody>
            </table>
            <div className={`line-separator`} />
            <div className={`step-table-warning`}>
                {__('* Taking account recycling flow rate = 25% Nominal DHW flow rate')}
            </div>
        </React.Fragment>

    }
}